export enum PulseSurveyQuestionType {
  Satisfaction = 'satisfaction',
  SatisfactionAndImportance = 'satisfaction_and_importance',
  OpenEnded = 'open_ended',
  OpenEndedAndImportance = 'open_ended_and_importance',
}
